import { z } from "zod";
export const clientOverrides = z.object({
    maxVideoBitRate: z.number().positive().nullish(),
    minBufferTime: z.number().positive().nullish(),
    maxBufferTime: z.number().positive().nullish(),
    burstEnabled: z.boolean().nullish(),
    sizeBasedResolutionCapEnabled: z.boolean().nullish(),
    separateVideoSocketEnabled: z.boolean().nullish(),
    videoCodecs: z.array(z.string()).nullish(),
});
//# sourceMappingURL=client-overrides.js.map